import React from "react"
import { IRecord } from "../types/schema"
import { HoverResourceLoader } from "./HoverResourceLoader"
import { buildRoute, eRoutes } from "../routes"
import { KeyValueList } from "../Components/KeyValueList"

type ILead = IRecord<"leads", "name" | "company_name" | "email" | "phone">

interface IProps {
  id?: string
  initialData?: ILead
  renderInlineLink?: "block" | "inline"
  noLink?: boolean
  inline?: boolean
}

export function HoverLeadLoader({ id, initialData, renderInlineLink, noLink, inline }: IProps) {
  const skeem = window.skeem

  async function loadData() {
    const lead = await skeem.fetchOne<ILead>({
      leads: {
        attributes: ["name", "company_name", "email", "phone"],
        filter: { matches: { id } },
      },
    })
    return lead
  }

  if (!id) {
    return <span>-</span>
  }

  return (
    <HoverResourceLoader
      reloadKey={id}
      inline={inline}
      loadData={loadData}
      initialData={initialData}
      resourceName="Lead"
      viewLink={noLink ? undefined : lead => buildRoute(eRoutes["/crm/leads/:id"], { id: lead.id })}
      renderHoverContentTitle={record => record.name}
      renderInlineLink={renderInlineLink}
      renderHoverContent={record => (
        <KeyValueList
          data={[
            { label: "Name", value: record.name },
            { label: "Company Name", value: record.company_name },
            { label: "Email", value: record.email },
            { label: "Phone", value: record.phone },
          ]}
        />
      )}
      renderTarget={record => <span>{record.name}</span>}
    />
  )
}
